module.exports = __webpack_public_path__ + "static/media/lindsey-j.4cd5809a.jpg";